import type { CommunityEvent, Registration } from "../../shared/contracts";
export function primaryAction(
  event: CommunityEvent,
  registration: Registration | null,
  now = Date.now(),
): string {
  if (event.status === "cancelled") return "cancelled";
  if (event.end && Date.parse(event.end) <= now) return "ended";
  if (registration) {
    if (["invited", "reschedule_pending"].includes(registration.status))
      return registration.invitationExpires &&
        Date.parse(registration.invitationExpires) > now
        ? "confirm"
        : "expired";
    if (registration.status === "confirmed") return "confirmed";
    if (registration.status === "waitlisted") return "waitlisted";
    if (registration.status === "preregistered")
      return event.status === "polling" &&
        event.choiceDeadline &&
        Date.parse(event.choiceDeadline) > now
        ? "change_choices"
        : "waiting";
  }
  if (event.hidden) return "closed";
  if (event.capacityMode !== "unlimited" && event.allowWaitlist !== true && (event as any).signupCount >= event.capacity && registration?.status !== "preregistered") return "full";
  if (
    event.status === "polling" &&
    event.choiceDeadline &&
    Date.parse(event.choiceDeadline) > now
  )
    return "choices";
  if (["polling", "awaiting_final", "awaiting_venue"].includes(event.status))
    return "waiting";
  if (
    event.status === "published" &&
    Date.parse(event.registrationDeadline) > now
  )
    return "register";
  return "closed";
}
export function safeReturnPath(value: string | null): string {
  if (!value?.startsWith("/") || value.includes("\\")) return "/me";
  try {
    const parsed = new URL(value, "https://juyici.invalid");
    return parsed.origin === "https://juyici.invalid"
      ? parsed.pathname + parsed.search + parsed.hash
      : "/me";
  } catch {
    return "/me";
  }
}
export function dateFilterValue(value: string | null) {
  if (!value || !Number.isFinite(Date.parse(value))) return "";
  return new Date(Date.parse(value) + 9 * 3_600_000).toISOString().slice(0, 10);
}
